/*
 *
 *  actions
 *
 */

import {
  LOAD_RECORDS_VALID_CACHE,

  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,

  CREATE_NOTIFICATION_DETAILS,
  CREATE_NOTIFICATION_DETAILS_SUCCESS,
  CREATE_NOTIFICATION_DETAILS_ERROR,

  UPDATE_NOTIFICATION_DETAILS,
  UPDATE_NOTIFICATION_DETAILS_SUCCESS,
  UPDATE_NOTIFICATION_DETAILS_ERROR,

  DELETE_NOTIFICATION_DETAILS,
  DELETE_NOTIFICATION_DETAILS_SUCCESS,
  DELETE_NOTIFICATION_DETAILS_ERROR,

  LOAD_RECORD_NOTIFICATION_DETAILS,
  LOAD_RECORD_NOTIFICATION_DETAILS_SUCCESS,
  LOAD_RECORD_NOTIFICATION_DETAILS_ERROR,

  UPDATE_NOTIFICATION_CHECKBOX_ERROR,
  UPDATE_NOTIFICATION_CHECKBOX,
  UPDATE_NOTIFICATION_CHECKBOX_SUCCESS,



} from "./constants"

export function loadRecordsCacheHit() {
  return {
    type: LOAD_RECORDS_VALID_CACHE,
  }
}

/**
 * @param {integer} id
 */
export function loadNotificationDetails(id) {
  return {
    type: LOAD_RECORD_NOTIFICATION_DETAILS,
    id,
  }
}



export function loadNotificationDetailsSuccess(notification_details) {
  return {
    type: LOAD_RECORD_NOTIFICATION_DETAILS_SUCCESS,
    notification_details,
  }
}

/**
 * @param {string} error
 */

export function loadNotificationDetailsError(error) {
  return {
    type: LOAD_RECORD_NOTIFICATION_DETAILS_ERROR,
    error,
  }
}
export function createNotificationRecord(submitValue) {
  //console.log("record", quotationData)
  return {
    type: CREATE_NOTIFICATION_DETAILS,
    submitValue,
  }
}

/**
 *
 * @param {object} record
 * @param {string} success
 * @returns
 */
export function createNotificationRecordSuccess(submitValue, success) {
  console.log("record", submitValue)
  return {
    type: CREATE_NOTIFICATION_DETAILS_SUCCESS,
    submitValue,
    success

  }
}

/**
 * @param {string} error
 */
export function createNotificationRecordError(error) {
  return {
    type: CREATE_NOTIFICATION_DETAILS_ERROR,
    error,
  }
}
export function updateNotificationRecord(updateNotificationData) {
  return {
    type: UPDATE_NOTIFICATION_DETAILS,
    updateNotificationData,
  }
}

/**
 *
 * @param {object} record
 * @param {string} success
 * @returns
 */
export function updateNotificationRecordSuccess(updateNotificationData, success) {
  return {
    type: UPDATE_NOTIFICATION_DETAILS_SUCCESS,
    updateNotificationData,
    success
  }
}

/**
 * @param {string} error
 */
export function updateNotificationRecordError(error) {
  return {
    type: UPDATE_NOTIFICATION_DETAILS_ERROR,
    error,
  }
}

/**
 *
 * @param {string} id
 * @returns
 */
export function deleteNotificationRecord(deleteNotificationData) {

  return {
    type: DELETE_NOTIFICATION_DETAILS,
    deleteNotificationData
  }
}

/**
 *
 * @param {integer} id
 * @param {string} success
 * @returns
 */
export function deleteNotificationRecordSuccess(
  deleteNotificationData
) {


  return {
    type: DELETE_NOTIFICATION_DETAILS_SUCCESS,
    deleteNotificationData,
  }
}

/**
 * @param {string} error
 */
export function deleteNotificationRecordError(error) {
  return {
    type: DELETE_NOTIFICATION_DETAILS_ERROR,
    error,
  }
}


export function loadRecordsMetaData() {
  return {
    type: LOAD_RECORDS_META_DATA,
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadRecordsMetaDataSuccess(quotationRecordsMetaData) {
  return {
    type: LOAD_RECORDS_META_DATA_SUCCESS,
    quotationRecordsMetaData,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadRecordsMetaDataError(error) {
  return {
    type: LOAD_RECORDS_META_DATA_ERROR,
    error,
  }
}

//UPDATE CHECKBOX NOTIFICATION

export function updateCheckbox(checkboxData) {
  return {
    type: UPDATE_NOTIFICATION_CHECKBOX ,
    checkboxData
  }
}

export function updateCheckboxSuccess(checkboxData) {
  return {
    type: UPDATE_NOTIFICATION_CHECKBOX_SUCCESS,
    checkboxData
  }
}

export function updateCheckboxError(error) {
  return {
    type: UPDATE_NOTIFICATION_CHECKBOX_ERROR,
    error
  }
}



const actions = {
  createNotificationRecord,
  createNotificationRecordError,
  createNotificationRecordSuccess,

  deleteNotificationRecord,
  deleteNotificationRecordSuccess,
  deleteNotificationRecordError,

  updateNotificationRecordError,
  updateNotificationRecord,
  updateNotificationRecordSuccess,

  loadNotificationDetails,
  loadNotificationDetailsSuccess,
  loadNotificationDetailsError,

  loadRecordsCacheHit,

  loadRecordsMetaData,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,

  updateCheckbox,
  updateCheckboxSuccess,
  updateCheckboxError
}

export default actions
